<template>
    <div class="text-center pb-48">
        <div class="-mt-24 inline-block w-240">
            <!--https://edit.lottiefiles.com/?src=https%3A%2F%2Fassets3.lottiefiles.com%2Fpackages%2Flf20_aBYmBC.json-->
            <!--https://lottiefiles.com/38061-search-->
            <lottie-animation
                v-if="showAnimation"
                :autoPlay="true"
                :loop="false"
                :animationData="animation"
            />
        </div>

        <div class="-mt-16 space-y-16">
            <div>
                <b v-if="title" class="text-heading-1 font-semibold">{{ title }}</b> <br/>
                <p class="text-primary-80 text-body-sm leading-relaxed" v-html="description"></p>
            </div>

            <div class="flex justify-center">
                <simple-button
                    :disabled="disabled"
                    :display="buttonColor"
                    :icon="buttonIcon"
                    look="primary"
                    v-if="showButton"
                    @click="handleClick"
                >
                    {{ buttonTextVal }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon';
import { LottieAnimation } from "lottie-web-vue";
import animation from '../../../../../../public/interim/animations/empty-state.json';
import SimpleButton from "./SimpleButton.vue";

export default {
    components: {
        SimpleButton,
        SvgIcon,
        LottieAnimation
    },
    props: {
        title: String,
        description: String,
        showAnimation: {
            // show the animation
            type: Boolean,
            default: true,
        },
        showButton: {
            // show the button
            type: Boolean,
            default: true,
        },
        buttonText: {
            // Button text
            type: String,
        },
        buttonIcon: {
            // Button icon
            type: String,
            default: 'replay',
        },
        buttonColor: {
            type: String,
            default: 'primary',
        },
        disabled: Boolean,
    },
    data: function () {
        return {
            animation,
            buttonTextVal: null,
        }
    },
    methods: {
        handleClick() {
            this.$emit('click');
        },
    },
    mounted() {
        this.buttonTextVal = this.buttonText ?? this.$t('general.try_again');
    }
};
</script>
